<template>
  <div>
    <!-- Top Bar with Social Icons and Contact Info -->
    <div class="sticky">
      <div class="top-bar">
        <div class="container d-flex justify-content-between">
          <!-- Social Icons on the Left -->
          <div>
            <a href="https://www.facebook.com/evacovation/" target="_blank" class="social-icon">
              <i class="fab fa-facebook-f"></i>
            </a>
            <!-- <a href="https://twitter.com" target="_blank" class="social-icon">
              <i class="fab fa-twitter"></i>
            </a> -->
            <a href="https://www.linkedin.com/company/evacovation/posts/?feedView=all" target="_blank" class="social-icon">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <!-- <a href="https://instagram.com" target="_blank" class="social-icon">
              <i class="fab fa-instagram"></i>
            </a> -->
          </div>

          <!-- Contact Info on the Right -->
          <div>
            <span>
              <a style="color: black !important;" href="mailto:info@evactracker.com.au">
                <i class="fas fa-envelope"></i> info@evactracker.com.au
              </a>
            </span>
            <span class="ml-3">
              <a style="color: black !important;" href="tel:+11234567890">
                <i class="fas fa-phone-alt"></i> +1 123 456 7890
              </a>
            </span>

          </div>
        </div>
      </div>

      <!-- Main Navbar -->
      <b-navbar toggleable="lg"  class="custom-navbar">
        <b-navbar-brand href="#">
          <img class="mb-1" :src="this.appLogoImage" alt="Logo" img-fluid width="80" />
          EvacTracker
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item :to="{ name: 'Home' }" class="nav-item">
              Home
            </b-nav-item>
            <b-nav-item href="#services" class="nav-item">
              Services
            </b-nav-item>
            <b-nav-item href="#members" class="nav-item">
              Board Members
            </b-nav-item>
            <b-nav-item href="#newsletter" class="nav-item">
              Contact
            </b-nav-item>
            <b-nav-item :to="{ name: 'Login' }" class="nav-item">
              <b-button
                type="submit"
                variant="loginBtn"
                class="loginBtn"
                block
              >
                Login
              </b-button>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import { $themeConfig } from "@themeConfig";

export default {
  name: 'NavbarComponent',
  created() {
    this.appName = $themeConfig.app.appName;
    this.appFullName = $themeConfig.app.appFullName;
    this.appLogoImage = $themeConfig.app.appLogoImage;
  },
};
</script>

<style scoped>
/* Top Bar Styles */
.top-bar {
  background-color: #f7f5f5; /* Updated to yellow */
  padding: 7px 30px; /* Increased padding for more height */
  font-size: 1.1rem; /* Increased font size */
  
}

.top-bar span {
  color: #333; /* Dark text to contrast with yellow background */
  font-size: 1.1rem; /* Increased font size for contact info */
}

.social-icon {
  color: #333; /* Dark color for social icons */
  margin-right: 15px; /* Increased margin */
  font-size: 1.4rem; /* Increased icon size */
  transition: color 0.3s ease-in-out;
}

.social-icon:hover {
  color: #007bff; /* Blue on hover */
}

/* Navbar Styles */
.custom-navbar {
  background-color: #fff;
  padding: 20px 30px; /* Increased padding for a more spacious navbar */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
 
}

.navbar-logo {
  height: 40px;
  margin-right: 10px;
}

.nav-item {
  display: flex;
  align-items: center;
  color: black;
  font-size: 1.3rem; /* Slightly increased font size */
  padding: 0.5rem 1.5rem; /* Adjusted padding for better spacing */
  transition: all 0.3s ease-in-out;
}

.nav-item:hover {
  color: #007bff; /* Blue hover effect */
}

.nav-item i {
  margin-right: 8px;
  font-size: 1.4rem; /* Increased icon size */
}


.ml-auto {
  margin-left: auto;
}

/* Padding for top and bottom */
.custom-navbar, .top-bar {
  padding-left: 30px;
  padding-right: 30px;
}

.loginBtn {
  background-color: #febc03;
  color: black;
}

.sticky{
  position: fixed;
  z-index: 1000;
  width: 100%;
  top: 0px;
}
</style>
